import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQubesosComponent } from './simple-icons-qubesos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQubesosComponent ],
    exports:      [ SimpleIconsQubesosComponent ],
    bootstrap:    []
})
export class SimpleIconsQubesosModule {}
